import { faTimes } from "@awesome.me/kit-2872b68069/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as Dialog from "@radix-ui/react-dialog";
import classNames from "classnames";

import { useCleanupAfterRadix } from "../../hooks/helperHooks";

interface ModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  description?: string;
  children?: React.ReactNode;
  openTriggerChild?: React.ReactNode;
  size?: "sm" | "md" | "lg";
  noClose?: boolean;
  hideTitle?: boolean;
  hideDescription?: boolean;
}

export default function Modal({
  open,
  onOpenChange,
  title,
  description,
  children,
  openTriggerChild,
  size = "md",
  noClose = false,
  hideTitle = false,
  hideDescription = false,
}: ModalProps) {
  useCleanupAfterRadix(open);

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      {openTriggerChild && (
        <Dialog.Trigger className="rounded">{openTriggerChild}</Dialog.Trigger>
      )}
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-[60] bg-black bg-opacity-50" />
        <Dialog.Content
          className={classNames(
            "fixed z-[60] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-4 rounded-md max-h-[80%] overflow-auto w-[90%]",
            {
              "max-w-[400px]": size === "sm",
              "max-w-[600px]": size === "md",
              "max-w-[800px]": size === "lg",
            },
          )}
          onInteractOutside={(e) => e.preventDefault()}
        >
          <Dialog.Title
            className={classNames(
              "font-semibold text-xl my-2 text-primary-500",
              {
                "sr-only": hideTitle,
              },
            )}
          >
            {title}
          </Dialog.Title>
          <Dialog.Description
            className={classNames("text-gray-700 mb-4", {
              "sr-only": hideDescription,
            })}
          >
            {description}
          </Dialog.Description>
          {children}
          <Dialog.Close
            className={classNames(
              "absolute top-3 right-3 rounded-full w-8 h-8 flex justify-center items-center bg-white",
              {
                hidden: noClose,
              },
            )}
          >
            <FontAwesomeIcon icon={faTimes} />
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
